// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `fi-document-template-item-options-site-map {
  display: block;
  padding: 16px;
}`, "",{"version":3,"sources":["webpack://./Source/app/document-template/document-template-item-options/document-template-item-options-site-map/document-template-item-options-site-map.component.scss"],"names":[],"mappings":"AAAA;EACI,cAAA;EACA,aAAA;AACJ","sourcesContent":["fi-document-template-item-options-site-map {\r\n    display: block;\r\n    padding: 16px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
